import { Globe, Filter } from "lucide-react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { COUNTRIES } from "@/lib/constants";
import { useLanguage } from "@/lib/LanguageContext";

const SearchConfig = ({ countryCode, adFormat, onCountryChange, onFormatChange }) => {
  const { t } = useLanguage();

  const adFormats = [
    { value: "ALL", label: t("formats.all") },
    { value: "TEXT", label: t("formats.text") },
    { value: "IMAGE", label: t("formats.image") },
    { value: "VIDEO", label: t("formats.video") },
  ];

  return (
    <div className="mt-8 space-y-6">
      <div className="flex items-center gap-3">
        <div className="w-8 h-8 rounded-lg bg-yellow-400/10 flex items-center justify-center text-yellow-400 font-bold text-sm">
          2
        </div>
        <h2
          className="text-xl font-bold text-white"
          style={{ fontFamily: 'Inter, sans-serif' }}
        >
          {t("config.stepTitle")}
        </h2>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="text-sm font-medium text-white/60 mb-2 block flex items-center gap-2">
            <Globe className="w-4 h-4" /> {t("config.countryLabel")}
          </label>
          <Select value={countryCode} onValueChange={onCountryChange}>
            <SelectTrigger
              className="rounded-xl bg-white/5 border-white/10 text-white hover:bg-white/10 focus:ring-yellow-400/30"
              data-testid="country-select"
            >
              <SelectValue />
            </SelectTrigger>
            <SelectContent className="bg-[#1a1f25] border-white/10">
              {COUNTRIES.map((country) => (
                <SelectItem
                  key={country.code}
                  value={country.code}
                  className="text-white hover:bg-white/10 focus:bg-white/10"
                >
                  {country.name} ({country.code})
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <div>
          <label className="text-sm font-medium text-white/60 mb-2 block flex items-center gap-2">
            <Filter className="w-4 h-4" /> {t("config.formatLabel")}
          </label>
          <Select value={adFormat} onValueChange={onFormatChange}>
            <SelectTrigger
              className="rounded-xl bg-white/5 border-white/10 text-white hover:bg-white/10 focus:ring-yellow-400/30"
              data-testid="format-select"
            >
              <SelectValue />
            </SelectTrigger>
            <SelectContent className="bg-[#1a1f25] border-white/10">
              {adFormats.map((format) => (
                <SelectItem
                  key={format.value}
                  value={format.value}
                  className="text-white hover:bg-white/10 focus:bg-white/10"
                >
                  {format.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </div>
    </div>
  );
};

export default SearchConfig;
